import React, { useEffect, useState } from 'react';

import Agreement from './Agreement';
import Verify from './Verify';

const UserLogout = () => {
  const [isNext, setNextStep] = useState(false);

  useEffect(() => {
    if(window?.__wxjs_environment === 'miniprogram') {
      const element = document.createElement('script');
      element.setAttribute('src', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
      element.setAttribute('type', 'text/javascript');
      document.body.appendChild(element);
    }
  }, [])
  return (
    <>
      {
        isNext ? (
          <Verify onBack={ () => setNextStep(false) } />
        ) : (
          <Agreement onNext={ () => setNextStep(true) } />
        )
      }
    </>
  )
}

export default UserLogout;